import PrintPreferenceTabs from "../templete/PrintPreferenceTabs";
const StockTransfer = () => {
  return (
    <PrintPreferenceTabs type="stock_transfer"></PrintPreferenceTabs>
  );
};
export default StockTransfer;
